import {DTO_STATE, UNITS} from '@mybake/ui/common/dictionary';
import {IDecoration} from '../../models/Decorations/IDecoration';
import {IOrderDecoration} from '../../models/Order/IOrderDecoration';
import {ISubOrderPackage} from '../../models/Order/ISubOrder';
import {IPackage} from '../../models/Packages/IPackage';
import {IRecipe} from '../../models/Recipe/IRecipe';

interface SubOrderCostParams {
    recipe?: IRecipe;
    fillingId?: number | string;
    count: number;
    recipeCounter: number;
    additionalRecipeCost?: number;
    packages?: IPackage[];
    selectedPackages?: ISubOrderPackage[];
    decorations?: IDecoration[];
    selectedDecorations?: IOrderDecoration[];
}

const toNumber = (value: unknown) => {
    const number = Number(value);
    return Number.isFinite(number) ? number : 0;
};

export const roundMoney = (value: number) => Math.round((value + Number.EPSILON) * 100) / 100;

export const calculateSubOrderCost = ({
    recipe,
    fillingId,
    count,
    recipeCounter,
    additionalRecipeCost,
    packages,
    selectedPackages = [],
    decorations,
    selectedDecorations = [],
}: SubOrderCostParams) => {
    const filling = recipe?.fillings?.find(item => String(item.id) === String(fillingId));
    const recipeAndFillingCost = toNumber(recipe?.price) + toNumber(filling?.proportionInfos?.[0]?.cost);

    const packagesCost = selectedPackages.reduce((sum, selectedPackage) => {
        if (selectedPackage.state === DTO_STATE.DTO_DELETED) return sum;

        const packageOption = packages?.find(item => String(item.id) === String(selectedPackage.packageId));
        const packageUnitCost = packageOption?.unit === UNITS.M
            ? toNumber(packageOption.pricePerUnit)
            : toNumber(packageOption?.price);
        return sum + packageUnitCost * toNumber(selectedPackage.quantity);
    }, 0);

    const decorationsCost = selectedDecorations.reduce((sum, selectedDecoration) => {
        if (selectedDecoration.state === DTO_STATE.DTO_DELETED) return sum;

        const decoration = decorations?.find(item => String(item.id) === String(selectedDecoration.decorationId));
        return sum + toNumber(decoration?.price) * toNumber(selectedDecoration.quantity);
    }, 0);

    const orderCount = toNumber(count);
    return roundMoney(
        recipeAndFillingCost * orderCount * toNumber(recipeCounter)
        + (packagesCost + decorationsCost) * orderCount
        + toNumber(additionalRecipeCost) * orderCount
    );
};
